import React from 'react'
import Dashboard from '../../dashboard'
import UserNewView from './page'

const UserNew = () => {
  return <Dashboard component={<UserNewView />} />
}

export default UserNew
